import React from "react";
import { Link } from "gatsby";
import { useLocation } from "@reach/router";
import "../styles/navBarSite-styles.css";
import LogoMaroon from "../images/summer-rect-logo.svg";
import LogoBlock from "../images/summer-at-block.svg";
import { Container, Row, Col } from "react-bootstrap";

const NavBarMainHome = ({ menuItems, interior, addClass, courseGroup }) => {

  const location = useLocation(); // Get the current URL path

  let additionalClassName = "";
  // Check if the location starts with either "/undergraduate" or "/pre-college"
  if (location.pathname.startsWith("/undergraduates/")) {
    additionalClassName = "undergraduates";
  } else if (location.pathname.startsWith("/pre-college/")) {
    additionalClassName = "pre-college";
  }

  // Recursive component to render nested navigation items up to 3 levels deep
  const RecursiveNavItem = ({ menuItem, parentSlug = "", depth = 1 }) => {
    if (depth === 0) {
      // Top-level item without wrapping sub-nav in an additional <li>
      return (
        menuItem.excludeFromNavigation !== true && (
          <li className="nav-item depth-1">
            {menuItem.displayItemName && (
              <Link to={`${parentSlug}/${menuItem.navSlug}`}>
                {menuItem.displayItemName}
              </Link>
            )}
            {menuItem.navNextLevel && menuItem.navNextLevel.length > 0 && (
              <ul className="sub-nav">
                {menuItem.navNextLevel
                  .filter(
                    (subItem) =>
                      subItem.excludeFromNavigation !== true // Filter sub-items
                  )
                  .map((subItem, subIndex) => (
                    <RecursiveNavItem
                      key={subIndex}
                      menuItem={subItem}
                      parentSlug={`${parentSlug}/${menuItem.navSlug}`}
                      depth={depth + 1}
                    />
                  ))}
              </ul>
            )}
          </li>
        )
      );
    } else {
      // Render nested items for sub-navigation
  
      return (
        
        menuItem.excludeFromNavigation !== true && (
        <li className={`nav-item depth-${depth}`}>
          {menuItem.displayItemName && (
            <Link to={`${parentSlug}/${menuItem.navSlug}`}>
              {menuItem.displayItemName}
            </Link>
          )}
          {menuItem.navNextLevel && menuItem.navNextLevel.length > 0 && (
            <ul className={`sub-nav depth-${depth}`}>
              {menuItem.navNextLevel.map((subItem, subIndex) => (
                <RecursiveNavItem
                  key={subIndex}
                  menuItem={subItem}
                  parentSlug={`${parentSlug}/${menuItem.navSlug}`}
                  depth={depth + 1}
                />
              ))}
            </ul>
          )}
        </li>
        )
      );
    }
  };
  // Filter menu items based on current path and courseGroup
  const isCoursesPage = location.pathname.startsWith("/courses/");
  const filteredMenuItems = menuItems.filter((menuItem) => {
    const isActiveNav = location.pathname.startsWith(`/${menuItem.navSlug}`);
    const shouldShowPreCollegeNav =
      isCoursesPage &&
      courseGroup === "Pre-College" &&
      menuItem.navSlug === "pre-college";
    const shouldShowUndergraduateNav =
      isCoursesPage &&
      courseGroup === "Undergraduate" &&
      menuItem.navSlug === "undergraduates";
    const shouldCustomBothNav = isCoursesPage && courseGroup === "Both";

    return (
      (shouldShowPreCollegeNav || shouldShowUndergraduateNav || isActiveNav) &&
      menuItem.navNextLevel &&
      menuItem.navNextLevel.length > 0
    );
  });

  return (
    <Container
      fluid
      id={`nav-screen`}
      className={interior ? `interior ${additionalClassName}` : ""}
    >
      <Container>
        <Row>
          <Col>
            <nav>
              <ul className="primary-nav">
                <li className="logo">
                  <Link to="/">
                    <img
                      src={LogoBlock}
                      alt="The University of Chicago Summer"
                    />
                  </Link>
                </li>

                {/* Render filtered navigation items */}
                {filteredMenuItems.map((menuItem, index) => (
                  <RecursiveNavItem key={index} menuItem={menuItem} />
                ))}

                {/* Custom Navigation for "Both" Course Group */}
                {isCoursesPage && courseGroup === "Both" && (
                  <nav>
                    <ul className="primary-nav" id="both">
                      <li className="nav-item">
                        <Link to={`/pre-college/pre-college-course-finder/`}>
                          Pre-College Course Finder
                        </Link>
                      </li>

                      <li className="nav-item">
                        <Link
                          to={`/undergraduates/undergraduate-course-finder/`}
                        >
                          Undergraduate Course Finder
                        </Link>
                      </li>
                    </ul>
                  </nav>
                )}
              </ul>
            </nav>
          </Col>
        </Row>
      </Container>
    </Container>
  );
};

export default NavBarMainHome;
